import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import { ArtistsCreditAccountResponse } from './types';

type GetCreditAccountsProps = {
  lastItemIdentifier?: string;
  searchNameTerm?: string;
  limit?: number;
};

/* eslint-disable camelcase */
type QueryParams = {
  limit: number;
  last_item_identifier?: string;
  search_name_term?: string;
};
/* eslint-enable camelcase */

export const getCreditAccounts = async ({ lastItemIdentifier, searchNameTerm, limit = 10 }: GetCreditAccountsProps) => {
  const url = `/web/studio/credits/accounts`;

  const queryParams: QueryParams = {
    limit,
    last_item_identifier: lastItemIdentifier,
  };

  if (searchNameTerm) {
    queryParams.search_name_term = searchNameTerm;
  }

  const response = await api.executeGetRequest<PaginatedListResponse<ArtistsCreditAccountResponse>>(url, queryParams);

  return response.data;
};
